import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { fetchCategoriesWithTourInfo } from "@/redux/slices/tourSlice";
import LoadingSpinner from "@/components/loading/LoadingSpinner";
import { Link } from "react-router-dom";

const sliderStyles = `
  .slick-slide {
    padding: 0 5px;
  }
  .slick-list {
    margin: 0 -5px; 
  }
`;

const Destination = () => {
  const dispatch = useDispatch();
  const { categories, loading, error } = useSelector((state) => state.tour);

  useEffect(() => {
    dispatch(fetchCategoriesWithTourInfo());
  }, [dispatch]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(categories.length, 6),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderCategories = () => {
    if (loading)
      return (
        <LoadingSpinner
          type="circle"
          color="#3498db"
          size={20}
          text="Đang tải dữ liệu..."
        />
      );
    if (error) return <div>Error: {error}</div>;
    if (!categories || categories.length === 0)
      return <div>No categories available</div>;

    const categoryItems = categories.map((category) => (
      <div
        className="categories-card wow fadeInUp"
        key={category.categoryId}
        data-wow-delay="0.5"
        style={{
          width: "100%",
          aspectRatio: "1 / 1",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Link
          to={`/tour-list?categoryId=${category.id}`}
          style={{ flex: "1 1 auto" }}
        >
          <img
            src={category.sampleImageUrl || "/default-image.jpg"}
            alt={category.categoryName}
            style={{
              width: "100%",
              height: "70%",
              aspectRatio: "1 / 1",
              objectFit: "cover",
            }}
          />
        </Link>

        <div
          className="cat-content d-flex align-items-center justify-content-between"
          style={{
            height: "30%",
            padding: "10px",
          }}
        >
          <div>
            <h5 className="text-white mb-1">{category.categoryName}</h5>
            <span className="text-white">{category.tourCount} Tours</span>
          </div>

          <Link
            className="loc-view-bottom"
            to={`/tour-list?categoryId=${category.categoryId}`}
          >
            <i className="isax isax-arrow-right-1"></i>
          </Link>
        </div>
      </div>
    ));

    return (
      <>
        <style>{sliderStyles}</style>
        <Slider {...settings}>{categoryItems}</Slider>
      </>
    );
  };

  return (
    <section className="section destination-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 wow fadeInUp" data-wow-delay="0.2s">
            <div className="section-header-six">
              <span className="badge badge-soft-primary rounded-pill mb-1">
                Danh mục nổi bật
              </span>
              <h2>
                Khách du lịch và sở thích<span className="text-primary">.</span>
              </h2>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-end">
              <Link className="btn btn-dark sec-head-btn" to={`/tour-list`}>
                Xem tất cả danh mục
                <i className="isax isax-arrow-right-3 ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
        {renderCategories()}
      </div>
    </section>
  );
};

export default Destination;
